import { ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';

export function oneMonthDateRangeValidator(): ValidatorFn {
  return (group: AbstractControl): ValidationErrors | null => {
    const fromDateStr = group.get('fromDate')?.value;
    const toDateStr = group.get('toDate')?.value;

    if (!fromDateStr || !toDateStr) return null;

    const [fromDay, fromMonth, fromYear] = fromDateStr.split('-').map(Number);
    const [toDay, toMonth, toYear] = toDateStr.split('-').map(Number);

    const fromDate = new Date(fromYear, fromMonth - 1, fromDay);
    const toDate = new Date(toYear, toMonth - 1, toDay);

    if (isNaN(fromDate.getTime()) || isNaN(toDate.getTime())) return null;

    // Make sure toDate is not more than one calendar month after fromDate
    const maxAllowedDate = new Date(fromDate);
    maxAllowedDate.setMonth(maxAllowedDate.getMonth() + 1);

    // Also subtract 1 day to make the range inclusive
    maxAllowedDate.setDate(maxAllowedDate.getDate() - 1);

    return toDate > maxAllowedDate ? { dateRangeExceedsOneMonth: true } : null;
  };
}
